/**
 * @store 门户 行情 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryVarietyList(_, data) {
      return await api.post(`/api/price/getVarietyLists`, data);
    },
    async queryList(_, data) {
      return await api.post(`/api/price/getPriceLists`, data);
    },
    async queryIndex(_, data) {
      return await api.post(`/api/price/getClassIndex`, data);
    },
    async queryChart(_, data) {
      return await api.post(`/api/price/getechart`, data);
    },
    async queryDetail(_, data) {
      return await api.post(`/api/price/detail`, data);
    },
  },
}
